export const appText = {
    loginText: {
        loginTitle: "ورود به پنل",
        loginData: "ورود به حساب کاربری",
        inputPlaceholder: "شماره تلفن همراه",
        passPlaceholder: "رمز عبور",
        errMessage: "نام کاربری یا رمز عبور اشتباه است",
        btnLogin: "ورود",
        btnRegister: 'ثبت نام',
        forgetPassword: 'فراموشی رمز عبور'
    },
    mapText: {

    },
    headerText: {
        logoutText: "خروج از حساب",
        adminText: "پنل مدیریت"
    },
    controlsText: {
        insuranceText: 'نقاط بیمه',
        samText: "نقاط سمیتیو",
        stationText: "ایستگاه‌های سینوپتیک هواشناسی"
    },
    layerSelectorText: {
        satelliteText: 'ماهواره‌ای',
        whiteText: 'سفید',
        blackText: "سیاه"
    },
    searchText: {
        titleText: "مختصات را وارد کرده و سپس نقطه مورد نظر را بر روی نقشه انتخاب کنید.",
        lonText: "طول جغرافیایی",
        latText: "عرض جغرافیایی",
        searchText: "جستجو",
    },
    mapText: {
        getDataText: "دریافت اطلاعات",
        getCsvText: "دانلود CSV",
        latAndLonText: " مختصات",
        loadingText: "در حال بارگذاری داده‌ها...",
        distanseText: "فاصله بین دو نقطه",
        meterText: "کیلومتر"
    },
    chartDataText: {
        t2m_dmax: "بیشینه روزانه دما",
        t2m_dmin: "کمینه روزانه دما",
        tp_dsum: "بارش روزانه",
        rh2m_dm: "میانگین روزانه رطوبت",
        rh2m_dmin: "کمینه روزانه رطوبت",
        rh2m_dmax: "بیشترین رطوبت نسبی",
        t2m_dm: "میانگین دما",
        t2m: "دما",
        tp: "بارش",
        fg10: "سرعت باد گاستی",
        d2m: "دمای نقطه شبنم",
        tcc: "پوشش ابری",
    }

}